export default {
    deviceStats: [],
    deviceData: [],
    isLoadingEvents: false,
    continuation: undefined,
};